import { useState } from "react";
import axios from "axios";
import { API_URL } from "../../../../support/api";
import { MediaValidationErrors } from "../../types/media";

const ACCEPT = [
	"image/png",
	"image/jpeg",
	"image/webp",
	"image/gif",
	"application/pdf",
].join(",");

type UploadMediaProps = {
	loading: boolean;
	handleFetchList: () => void;
};

export const UploadMedia = ({ loading, handleFetchList }: UploadMediaProps) => {
	const [name, setName] = useState("");
	const [altText, setAltText] = useState("");
	const [caption, setCaption] = useState("");
	const [files, setFiles] = useState<FileList | null>(null);
	const [validationErrors, setValidationErrors] =
		useState<MediaValidationErrors>({});

	const handleSubmit = async () => {
		setValidationErrors({});
		if (!files?.length) {
			setValidationErrors({ media: ["Select at least one file."] });
			return;
		}
		try {
			const formData = new FormData();
			formData.append("name", name);
			formData.append("alt_text", altText);
			formData.append("caption", caption);
			for (let i = 0; i < files.length; i++) {
				formData.append("media[]", files[i]);
			}
			const result = await axios.post(
				`${API_URL}/v1/media-library/store`,
				formData,
				{
					headers: { "Content-Type": "multipart/form-data" },
				}
			);
			if (result.data?.value?.success) {
				setName("");
				setAltText("");
				setCaption("");
				setFiles(null);
				handleFetchList();
			}
		} catch (error: unknown) {
			const err = error as { response?: { data?: { errors?: MediaValidationErrors } } };
			if (err?.response?.data?.errors) {
				setValidationErrors(err.response.data.errors);
			}
		}
	};

	return (
		<div
			className={`card card-custom card-flush ${
				loading ? "overlay overlay-block" : ""
			}`}
		>
			<div className="pt-8 card-header">
				<h3 className="card-title">Upload media</h3>
			</div>
			<div
				className={`card-body py-5 ${loading ? "overlay-wrapper" : ""}`}
			>
				<div className="grid gap-8 justify-content-start">
					<div className="w-100">
						<div className="media-library-properties">
							<div className="media-library-field mb-3">
								<label className="media-library-label form-label">
									Name
								</label>
								<input
									className="form-control form-control-solid"
									value={name}
									onChange={(e) => setName(e.target.value)}
								/>
								{validationErrors.name?.map((error) => (
									<p
										key={error}
										className="media-library-text-error text-danger small mt-1"
									>
										{error}
									</p>
								))}
							</div>
							<div className="media-library-field mb-3">
								<label className="media-library-label form-label">
									Alt text
								</label>
								<input
									className="form-control form-control-solid"
									value={altText}
									onChange={(e) => setAltText(e.target.value)}
								/>
								{validationErrors.alt_text?.map((error) => (
									<p
										key={error}
										className="media-library-text-error text-danger small mt-1"
									>
										{error}
									</p>
								))}
							</div>
							<div className="media-library-field mb-3">
								<label className="media-library-label form-label">
									Caption
								</label>
								<input
									className="form-control form-control-solid"
									value={caption}
									onChange={(e) => setCaption(e.target.value)}
								/>
								{validationErrors.caption?.map((error) => (
									<p
										key={error}
										className="media-library-text-error text-danger small mt-1"
									>
										{error}
									</p>
								))}
							</div>
							<div className="media-library-field mb-3">
								<label className="media-library-label form-label">
									Files
								</label>
								<input
									type="file"
									className="form-control form-control-solid"
									accept={ACCEPT}
									multiple
									onChange={(e) =>
										setFiles(e.target.files || null)
									}
								/>
								{validationErrors.media?.map((error) => (
									<p
										key={error}
										className="media-library-text-error text-danger small mt-1"
									>
										{error}
									</p>
								))}
							</div>
						</div>
					</div>
					<button
						type="button"
						className="mt-5 btn btn-info btn-sm"
						onClick={handleSubmit}
					>
						Submit
					</button>
				</div>
			</div>
		</div>
	);
};
